require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-transforming-lives-through-tech-education.json") })
        }
      }, "path---blog-transforming-lives-through-tech-education");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-transforming-lives-through-tech-education!./.cache/json/blog-transforming-lives-through-tech-education.json
// module id = 1120
// module chunks = 231608221292675